import ComparableChart from 'components/ComparableChart/ComparableChart'
import { DEFAULT_COLOR } from 'components/ComparableChart/constants'
import moment from 'locale/momentLocale'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { handleNullCase, momentValidDateFormat, sumBy, thousandsSeparator } from 'utils'

const compareDates = (a, b) => (moment(a.date).isBefore(b.date) ? -1 : 1)

class TrafficTab extends Component {
  getTrafficAvg = history => {
    const sum = sumBy(history, x => x.trafficCurrent)

    return history.length > 0 ? Math.round(sum / history.length) : 0
  }

  render() {
    const { t: translate, trafficCurrent, trafficCompared, trafficHistory } = this.props
    const formattedCurrentDate = moment().format(momentValidDateFormat)
    const data = trafficHistory.sort(compareDates).map(item => {
      const itemDate = moment(item.date).format(t('date.dayMonthFormat'))
      const formattedDate = `${itemDate[0].toUpperCase()}${itemDate.slice(1)}`

      return {
        color: moment(formattedCurrentDate).isSame(item.date, 'day') ? '#75aedb' : DEFAULT_COLOR,
        compared: handleNullCase(item.trafficCompared),
        comparedLabel: handleNullCase(thousandsSeparator(item.trafficCompared)),
        current: item.trafficCurrent,
        currentLabel: thousandsSeparator(item.trafficCurrent),
        tooltipHeader: formattedDate,
        xAxisLabel: formattedDate.split(' '),
      }
    })
    const avgTraffic = trafficHistory.length > 0 ? sumBy(trafficHistory, x => x.trafficCurrent) / trafficHistory.length : null

    return (
      <>
        <div className="flex-row">
          <div className="traffic-details">
            <div>
              {translate('revenue.details.traffic.today')}:
              <span className="traffic-details_value">{thousandsSeparator(trafficCurrent)}</span>
            </div>
            <div>
              {translate('revenue.details.traffic.vsLY')}:
              <span className="traffic-details_value">{handleNullCase(thousandsSeparator(trafficCompared))}</span>
            </div>
            <div>
              {translate('revenue.details.traffic.average')}:
              <span className="traffic-details_value">{thousandsSeparator(this.getTrafficAvg(trafficHistory))}</span>
            </div>
          </div>
        </div>
        <div className="flex-column traffic-chart">
          <h4>{translate('revenue.details.traffic.week')}</h4>

          <ComparableChart
            barLabelFormatter={value => (value ? thousandsSeparator(value) : '')}
            data={data}
            height="130px"
            referenceLineValue={avgTraffic}
            tooltipLabelFormatter={(value, dataKey) =>
              `${t(dataKey === 'current' ? 'revenue.details.traffic.day' : 'revenue.details.traffic.LY')}: ${thousandsSeparator(
                value,
              )}`
            }
            yAxisLabelFormatter={value => thousandsSeparator(value)}
          />
        </div>
      </>
    )
  }
}

TrafficTab.propTypes = {
  t: PropTypes.func,
  trafficCompared: PropTypes.number,
  trafficCurrent: PropTypes.number,
  trafficHistory: PropTypes.arrayOf(PropTypes.object),
}

export default withTranslation()(TrafficTab)
